import { BehaviorSubject } from 'rxjs';

import { globalActions } from '../global-actions';

import { nextState } from './next-state';
import { addToStateHistory } from './save-stores-history';

export function createStore({ initialState, reducer, name }) {
  const store = new BehaviorSubject(initialState || {});
  globalActions.subscribe((action) => nextState({ store, reducer, action }));
  if (name) {
    addToStateHistory(name, store);
  }
  return store;
}
